import { render, staticRenderFns } from "./goodsBatchPrint.vue?vue&type=template&id=04601015&scoped=true&"
import script from "./goodsBatchPrint.vue?vue&type=script&lang=js&"
export * from "./goodsBatchPrint.vue?vue&type=script&lang=js&"
import style0 from "./goodsBatchPrint.vue?vue&type=style&index=0&id=04601015&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04601015",
  null
  
)

export default component.exports